<template>
  <div class="box p-4 mb-4">
    <div class="grid grid-cols-3 gap-4">

      <div class="md:col-3 col-span-3">
        <div class="flex dark:bg-dark-1 sm:justify-end">
          <router-link
            :to="{name: 'pharmasan.contabilidad.amortizaciones.productos-financieros.pagos.made', params: {id:infoProductComputed.id}}" target="_blank" class="w-1/3 sm:w-auto"
          >
            <Button label="Det. Pagos Realizados" class="p-button-primary p-button-xs ml-0 md:ml-2 w-full sm:w-auto" />
          </router-link>
          <router-link
            :to="{name: 'pharmasan.contabilidad.amortizaciones.productos-financieros.tabla', params: {id:infoProductComputed.id}}" target="_blank" class="w-1/3 sm:w-auto"
          >
            <Button label="Det. Amortizaciones" class="p-button-secondary p-button-xs ml-0 md:ml-2 w-full sm:w-auto" />
          </router-link>
          <Button
            :label="isShowChart ? 'Ocultar Gráfica' : 'Ver Gráfica'"
            class="p-button-raised p-button-xs ml-0 md:ml-2 w-1/3 sm:w-auto"
            :class="[isShowChart ? 'p-button-warning' : 'p-button-success']"
            @click='isShowChart = !isShowChart'
          />
        </div>
      </div>

      <div class="md:col-3 col-span-3">
        <div class="flex w-full justify-between flex-col md:flex-row lg:flex-row xl:flex-row xxl:flex-row flex-wrap">
          <div class="flex items-center mr-3">
            <div class="symbol symbol-circle symbol-gray symbol-40 flex-shrink-0 mr-3 hidden sm:inline-block">
              <div class="symbol-label">
                  <span class="svg-icon svg-icon-info">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <rect x="0" y="0" width="24" height="24"></rect>
                        <path d="M12,4.56204994 L7.76822128,9.6401844 C7.4146572,10.0644613 6.7840925,10.1217854 6.3598156,9.76822128 C5.9355387,9.4146572 5.87821464,8.7840925 6.23177872,8.3598156 L11.2317787,2.3598156 C11.6315738,1.88006147 12.3684262,1.88006147 12.7682213,2.3598156 L17.7682213,8.3598156 C18.1217854,8.7840925 18.0644613,9.4146572 17.6401844,9.76822128 C17.2159075,10.1217854 16.5853428,10.0644613 16.2317787,9.6401844 L12,4.56204994 Z" fill="#000000" fill-rule="nonzero" opacity="0.3"></path>
                        <path d="M3.5,9 L20.5,9 C21.0522847,9 21.5,9.44771525 21.5,10 C21.5,10.132026 21.4738562,10.2627452 21.4230769,10.3846154 L17.7692308,19.1538462 C17.3034221,20.271787 16.2111026,21 15,21 L9,21 C7.78889745,21 6.6965779,20.271787 6.23076923,19.1538462 L2.57692308,10.3846154 C2.36450587,9.87481408 2.60558331,9.28934029 3.11538462,9.07692308 C3.23725479,9.02614384 3.36797398,9 3.5,9 Z M12,17 C13.1045695,17 14,16.1045695 14,15 C14,13.8954305 13.1045695,13 12,13 C10.8954305,13 10,13.8954305 10,15 C10,16.1045695 10.8954305,17 12,17 Z" fill="#000000"></path>
                      </g>
                    </svg>
                  </span>
              </div>
            </div>
            <div class="flex sm:flex-col w-full justify-between pb-2">
              <span class="text-sm font-normal text-gray-600 flex-shrink-0"># Obligación</span>
              <span style="border-bottom: 1px dotted #ccc" class="w-full flex-shrink-1 mx-2 sm:hidden"></span>
              <span class="text-sm font-bold text-right sm:text-left flex-shrink-0">{{ infoProductComputed.obligationNumber }}</span>
            </div>
          </div>
          <div class="flex items-center mr-3" v-if="infoProductComputed.creditCardQuota">
            <div class="symbol symbol-circle symbol-gray symbol-40 flex-shrink-0 mr-3 hidden sm:inline-block">
              <div class="symbol-label">
                  <span class="svg-icon svg-icon-success">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <rect x="0" y="0" width="24" height="24"/>
                        <path d="M6.5,16 L7.5,16 C8.32842712,16 9,16.6715729 9,17.5 L9,19.5 C9,20.3284271 8.32842712,21 7.5,21 L6.5,21 C5.67157288,21 5,20.3284271 5,19.5 L5,17.5 C5,16.6715729 5.67157288,16 6.5,16 Z M16.5,16 L17.5,16 C18.3284271,16 19,16.6715729 19,17.5 L19,19.5 C19,20.3284271 18.3284271,21 17.5,21 L16.5,21 C15.6715729,21 15,20.3284271 15,19.5 L15,17.5 C15,16.6715729 15.6715729,16 16.5,16 Z" fill="#000000" opacity="0.3"/>
                        <path d="M5,4 L19,4 C20.1045695,4 21,4.8954305 21,6 L21,17 C21,18.1045695 20.1045695,19 19,19 L5,19 C3.8954305,19 3,18.1045695 3,17 L3,6 C3,4.8954305 3.8954305,4 5,4 Z M15.5,15 C17.4329966,15 19,13.4329966 19,11.5 C19,9.56700338 17.4329966,8 15.5,8 C13.5670034,8 12,9.56700338 12,11.5 C12,13.4329966 13.5670034,15 15.5,15 Z M15.5,13 C16.3284271,13 17,12.3284271 17,11.5 C17,10.6715729 16.3284271,10 15.5,10 C14.6715729,10 14,10.6715729 14,11.5 C14,12.3284271 14.6715729,13 15.5,13 Z M7,8 L7,8 C7.55228475,8 8,8.44771525 8,9 L8,11 C8,11.5522847 7.55228475,12 7,12 L7,12 C6.44771525,12 6,11.5522847 6,11 L6,9 C6,8.44771525 6.44771525,8 7,8 Z" fill="#000000"/>
                      </g>
                    </svg>
                  </span>
              </div>
            </div>
            <div class="flex sm:flex-col w-full justify-between pb-2">
              <span class="text-sm font-normal text-gray-600 flex-shrink-0">Cupo</span>
              <span style="border-bottom: 1px dotted #ccc" class="w-full flex-shrink-1 mx-2 sm:hidden"></span>
              <span class="text-sm font-bold text-right sm:text-left flex-shrink-0">{{ $h.formatCurrency(parseInt(infoProductComputed.creditCardQuota)) }}</span>
            </div>
          </div>
          <div class="flex items-center mr-3">
            <div class="symbol symbol-circle symbol-gray symbol-40 flex-shrink-0 mr-3 hidden sm:inline-block">
              <div class="symbol-label">
                  <span class="svg-icon svg-icon-danger">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <rect x="0" y="0" width="24" height="24"/>
                        <path d="M6.5,16 L7.5,16 C8.32842712,16 9,16.6715729 9,17.5 L9,19.5 C9,20.3284271 8.32842712,21 7.5,21 L6.5,21 C5.67157288,21 5,20.3284271 5,19.5 L5,17.5 C5,16.6715729 5.67157288,16 6.5,16 Z M16.5,16 L17.5,16 C18.3284271,16 19,16.6715729 19,17.5 L19,19.5 C19,20.3284271 18.3284271,21 17.5,21 L16.5,21 C15.6715729,21 15,20.3284271 15,19.5 L15,17.5 C15,16.6715729 15.6715729,16 16.5,16 Z" fill="#000000" opacity="0.3"/>
                        <path d="M5,4 L19,4 C20.1045695,4 21,4.8954305 21,6 L21,17 C21,18.1045695 20.1045695,19 19,19 L5,19 C3.8954305,19 3,18.1045695 3,17 L3,6 C3,4.8954305 3.8954305,4 5,4 Z M15.5,15 C17.4329966,15 19,13.4329966 19,11.5 C19,9.56700338 17.4329966,8 15.5,8 C13.5670034,8 12,9.56700338 12,11.5 C12,13.4329966 13.5670034,15 15.5,15 Z M15.5,13 C16.3284271,13 17,12.3284271 17,11.5 C17,10.6715729 16.3284271,10 15.5,10 C14.6715729,10 14,10.6715729 14,11.5 C14,12.3284271 14.6715729,13 15.5,13 Z M7,8 L7,8 C7.55228475,8 8,8.44771525 8,9 L8,11 C8,11.5522847 7.55228475,12 7,12 L7,12 C6.44771525,12 6,11.5522847 6,11 L6,9 C6,8.44771525 6.44771525,8 7,8 Z" fill="#000000"/>
                      </g>
                    </svg>
                  </span>
              </div>
            </div>
            <div class="flex sm:flex-col w-full justify-between pb-2">
              <span class="text-sm font-normal text-gray-600 flex-shrink-0">Valor Total Deuda</span>
              <span style="border-bottom: 1px dotted #ccc" class="w-full flex-shrink-1 mx-2 sm:hidden"></span>
              <span class="text-sm font-bold text-right sm:text-left flex-shrink-0">{{ $h.formatCurrency(parseInt(infoProductComputed.disbursement - infoProductComputed.totalCancelado )) }}</span>
            </div>
          </div>
          <div class="flex items-center mr-3">
            <div class="symbol symbol-circle symbol-gray symbol-40 flex-shrink-0 mr-3 hidden sm:inline-block">
              <div class="symbol-label">
                  <span class="svg-icon svg-icon-primary">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <rect x="0" y="0" width="24" height="24"/>
                        <rect fill="#000000" opacity="0.3" x="2" y="2" width="10" height="12" rx="2"/>
                        <path d="M4,6 L20,6 C21.1045695,6 22,6.8954305 22,8 L22,20 C22,21.1045695 21.1045695,22 20,22 L4,22 C2.8954305,22 2,21.1045695 2,20 L2,8 C2,6.8954305 2.8954305,6 4,6 Z M18,16 C19.1045695,16 20,15.1045695 20,14 C20,12.8954305 19.1045695,12 18,12 C16.8954305,12 16,12.8954305 16,14 C16,15.1045695 16.8954305,16 18,16 Z" fill="#000000"/>
                      </g>
                    </svg>
                  </span>
              </div>
            </div>
            <div class="flex sm:flex-col w-full justify-between pb-2">
              <span class="text-sm font-normal text-gray-600 flex-shrink-0"># Cuota</span>
              <span style="border-bottom: 1px dotted #ccc" class="w-full flex-shrink-1 mx-2 sm:hidden"></span>
              <span class="text-sm font-bold text-right sm:text-left flex-shrink-0">{{ infoProductComputed.numberQuote }}/{{ infoProductComputed.term }}</span>
            </div>
          </div>
          <div class="flex items-center mr-3">
            <div class="symbol symbol-circle symbol-gray symbol-40 flex-shrink-0 mr-3 hidden sm:inline-block">
              <div class="symbol-label">
                  <span class="svg-icon svg-icon-danger">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <rect x="0" y="0" width="24" height="24"/>
                        <rect fill="#000000" opacity="0.3" x="7" y="4" width="10" height="4"/>
                        <path d="M7,2 L17,2 C18.1045695,2 19,2.8954305 19,4 L19,20 C19,21.1045695 18.1045695,22 17,22 L7,22 C5.8954305,22 5,21.1045695 5,20 L5,4 C5,2.8954305 5.8954305,2 7,2 Z M8,12 C8.55228475,12 9,11.5522847 9,11 C9,10.4477153 8.55228475,10 8,10 C7.44771525,10 7,10.4477153 7,11 C7,11.5522847 7.44771525,12 8,12 Z M8,16 C8.55228475,16 9,15.5522847 9,15 C9,14.4477153 8.55228475,14 8,14 C7.44771525,14 7,14.4477153 7,15 C7,15.5522847 7.44771525,16 8,16 Z M12,12 C12.5522847,12 13,11.5522847 13,11 C13,10.4477153 12.5522847,10 12,10 C11.4477153,10 11,10.4477153 11,11 C11,11.5522847 11.4477153,12 12,12 Z M12,16 C12.5522847,16 13,15.5522847 13,15 C13,14.4477153 12.5522847,14 12,14 C11.4477153,14 11,14.4477153 11,15 C11,15.5522847 11.4477153,16 12,16 Z M16,12 C16.5522847,12 17,11.5522847 17,11 C17,10.4477153 16.5522847,10 16,10 C15.4477153,10 15,10.4477153 15,11 C15,11.5522847 15.4477153,12 16,12 Z M16,16 C16.5522847,16 17,15.5522847 17,15 C17,14.4477153 16.5522847,14 16,14 C15.4477153,14 15,14.4477153 15,15 C15,15.5522847 15.4477153,16 16,16 Z M16,20 C16.5522847,20 17,19.5522847 17,19 C17,18.4477153 16.5522847,18 16,18 C15.4477153,18 15,18.4477153 15,19 C15,19.5522847 15.4477153,20 16,20 Z M8,18 C7.44771525,18 7,18.4477153 7,19 C7,19.5522847 7.44771525,20 8,20 L12,20 C12.5522847,20 13,19.5522847 13,19 C13,18.4477153 12.5522847,18 12,18 L8,18 Z M7,4 L7,8 L17,8 L17,4 L7,4 Z" fill="#000000"/>
                      </g>
                    </svg>
                  </span>
              </div>
            </div>
            <div class="flex sm:flex-col w-full justify-between pb-2">
              <span class="text-sm font-normal text-gray-600 flex-shrink-0">Valor Cuota</span>
              <span style="border-bottom: 1px dotted #ccc" class="w-full flex-shrink-1 mx-2 sm:hidden"></span>
              <span class="text-sm font-bold text-right sm:text-left flex-shrink-0">{{ $h.formatCurrency(parseInt(infoProductComputed.quote )) }}</span>
            </div>
          </div>
          <div class="flex items-center mr-3">
            <div class="symbol symbol-circle symbol-gray symbol-40 flex-shrink-0 mr-3 hidden sm:inline-block">
              <div class="symbol-label">
                <!--begin::Svg Icon | path: assets/media/icons/duotune/general/gen014.svg-->
                <span class="svg-icon svg-icon-warning"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path opacity="0.3" d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z" fill="black"/>
                    <path d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z" fill="black"/>
                    <path d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z" fill="black"/>
                    </svg>
                  </span>
                <!--end::Svg Icon-->
              </div>
            </div>
            <div class="flex sm:flex-col w-full justify-between pb-2">
              <span class="text-sm font-normal text-gray-600 flex-shrink-0">Fecha Próximo Pago</span>
              <span style="border-bottom: 1px dotted #ccc" class="w-full flex-shrink-1 mx-2 sm:hidden"></span>
              <span class="text-sm font-bold text-right sm:text-left flex-shrink-0">{{ infoProductComputed.fechaPago }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="md:col-span-3 col-span-3" v-if="isShowChart">
        <chart-product :totalCancelado="infoProductComputed.totalCancelado" :totalSaldo="infoProductComputed.totalSaldo" :productId="infoProductComputed.id" />
      </div>

    </div>
  </div>
</template>
<script>

import { computed, defineAsyncComponent, ref } from 'vue'

export default {
  name: 'VizualizarProductos',
  components: {
    chartProduct: defineAsyncComponent(() => import('../chart'))
  },
  props: {
    infoProducto: {
      type: Object,
      required: true,
      default: () => ({
        disbursement: '',
        fechaPago: '',
        id: null,
        numberQuote: null,
        obligationNumber: '',
        quote: null,
        quotesCanceladas: null,
        term: null,
        totalCancelado: null,
        totalSaldo: null,
        creditCardQuota: null
      })
    }

  },
  setup (props) {
    const isShowChart = ref(false)

    const infoProductComputed = computed(() => {
      return props.infoProducto
    })

    return {
      infoProductComputed,
      isShowChart
    }
  }
}
</script>

<style scoped lang="scss">
.symbol {
  flex-shrink: 0;
  position: relative;
}
.symbol.symbol-circle {
  border-radius: 50%;
}
.symbol.symbol-40 > img {
  width: 100%;
  max-width: 40px;
  height: 40px;
}
.symbol.symbol-40 .symbol-label {
  width: 40px;
  height: 40px;
}
.symbol.symbol-40 .symbol-badge {
  width: 12px;
  height: 12px;
  top: -6px;
  right: -6px;
}
.symbol.symbol-40 .symbol-badge.symbol-badge-bottom {
  top: auto;
  bottom: -6px;
}
.symbol.symbol-40.symbol-circle .symbol-badge {
  top: -3.8px;
  right: -3.8px;
}
.symbol.symbol-40.symbol-circle .symbol-badge.symbol-badge-bottom {
  top: auto;
  bottom: -3.8px;
}
.svg-icon svg {
  height: 1.5rem;
  width: 1.5rem;
}
.svg-icon.svg-icon-lg svg {
  height: 1.75rem !important;
  width: 1.75rem !important;
}
.svg-icon.svg-icon-gray-500 svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #A1A5B7;
}
.symbol.symbol-white .symbol-label {
  background-color: #ffffff;
  color: #3F4254;
}
.symbol.symbol-gray .symbol-label {
  background-color: #DFE1E8;
  color: #ffffff;
}
.svg-icon {
  line-height: 1;
}
.svg-icon svg {
  height: 1.15rem;
  width: 1.15rem;
}
.svg-icon svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #A1A5B7;
}
.svg-icon svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.svg-icon.svg-icon-white svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #ffffff;
}
.svg-icon.svg-icon-white svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.svg-icon.svg-icon-primary svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #009EF7;
}
.svg-icon.svg-icon-primary svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.svg-icon.svg-icon-secondary svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #E4E6EF;
}
.svg-icon.svg-icon-secondary svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.svg-icon.svg-icon-light svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #F5F8FA;
}
.svg-icon.svg-icon-light svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.svg-icon.svg-icon-success svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #50CD89;
}
.svg-icon.svg-icon-success svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.svg-icon.svg-icon-info svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #7239EA;
}
.svg-icon.svg-icon-info svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.svg-icon.svg-icon-warning svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #FFC700;
}
.svg-icon.svg-icon-warning svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.svg-icon.svg-icon-danger svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #F1416C;
}
.svg-icon.svg-icon-danger svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.svg-icon.svg-icon-dark svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #181C32;
}
.svg-icon.svg-icon-dark svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.svg-icon.svg-icon-muted svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #A1A5B7;
}
.svg-icon.svg-icon-muted svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.svg-icon.svg-icon-gray-100 svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #F5F8FA;
}
.svg-icon.svg-icon-gray-100 svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.svg-icon.svg-icon-gray-200 svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #EFF2F5;
}
.svg-icon.svg-icon-gray-200 svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.svg-icon.svg-icon-gray-300 svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #E4E6EF;
}
.svg-icon.svg-icon-gray-300 svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.svg-icon.svg-icon-gray-400 svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #B5B5C3;
}
.svg-icon.svg-icon-gray-400 svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.svg-icon.svg-icon-gray-500 svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #A1A5B7;
}
.svg-icon.svg-icon-gray-500 svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.svg-icon.svg-icon-gray-600 svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #7E8299;
}
.svg-icon.svg-icon-gray-600 svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.svg-icon.svg-icon-gray-700 svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #5E6278;
}
.svg-icon.svg-icon-gray-700 svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.svg-icon.svg-icon-gray-800 svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #3F4254;
}
.svg-icon.svg-icon-gray-800 svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
.svg-icon.svg-icon-gray-900 svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #181C32;
}
.svg-icon.svg-icon-gray-900 svg:hover [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
}
</style>
